import { activitiesRoutes } from '@/router';

const mixin = {
  computed: {
    isActivities() {
      return activitiesRoutes.indexOf(this.$route.name) !== -1;
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/activitiesModule.js